"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var tyrande_1 = require("tyrande");
var WithEZSpm_1 = require("../../../components/WithEZSpm");
var classnames_1 = require("classnames");
var styles = require("./index.scss");
var NavBar = (function (_super) {
    __extends(NavBar, _super);
    function NavBar(props) {
        var _this = _super.call(this, props) || this;
        _this.onScroll = function (linkId, order, link) { return function () {
            var linkID = linkId.substr(1);
            var dom = document.getElementById(linkID);
            dom.scrollIntoView({ block: "start" });
            setTimeout(function () {
                window.scrollBy(0, -_this.props.stickToTop);
            }, 0);
            _this.sendTSpm(order, link);
        }; };
        _this.state = {};
        return _this;
    }
    NavBar.prototype.componentDidMount = function () {
    };
    NavBar.prototype.sendTSpm = function (order, link) {
        var _a = this.props.spm, activityId = _a.activityId, pageId = _a.pageId, componentType = _a.componentType, site = _a.site, index = _a.index;
        var params = {
            site: site,
            activityId: activityId,
            pageId: pageId,
            channel: index,
            channelContent: {
                type: componentType,
                order: order,
                content: link
            }
        };
        tyrande_1.sendEzspm(params, {}, false);
    };
    NavBar.prototype.render = function () {
        var _this = this;
        var navModules = this.props.navModules;
        if (!navModules || !navModules.length) {
            return null;
        }
        var id = this.props.spm.position;
        return (React.createElement("div", { id: id, className: styles.Nav }, navModules.map(function (item, index) {
            var _a;
            var initColor = item.ui.bgColor === ("#fff" || "#ffffff");
            return (React.createElement("a", { key: index, onClick: _this.onScroll(item.icon.link, index + 1, item.icon.link) },
                React.createElement("span", { className: classnames_1.default((_a = {}, _a[styles.init] = initColor, _a)), style: { backgroundColor: item.ui.bgColor } }, item.icon.title),
                React.createElement("img", { src: item.icon.img, alt: "" })));
        })));
    };
    NavBar.defaultProps = {
        stickToTop: 0
    };
    return NavBar;
}(React.Component));
exports.default = WithEZSpm_1.default(NavBar);
